import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Typography } from '@material-ui/core';

import useStyles from './styles';

interface IImageSpoilerProps {
  image: string;
}

const ImageSpoiler: React.FC<IImageSpoilerProps> = ({ image }) => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  const toggleOpen = () => setOpen(open => !open);

  return (
    <Box className={classes.imageContainer}>
      <Button onClick={toggleOpen} fullWidth>
        {
          open ? (
            <Box className={classes.eyeContainer}>
              <FontAwesomeIcon icon="eye-slash" className={classes.icon} />
              <Typography>Hide</Typography>
            </Box>
          ) : (
            <Box className={classes.eyeContainer}>
              <FontAwesomeIcon icon="eye" className={classes.icon} />
              <Typography>See Example</Typography>
            </Box>
          )
        }
      </Button>
      {open && <img className={classes.image} src={image} alt="example" />}
    </Box>
  );
};

export default ImageSpoiler;
